// extracted by mini-css-extract-plugin
module.exports = {"imageBlock":"poland-module--imageBlock--2Uu7S","image":"poland-module--image--f2Yog"};